import React, { useEffect } from "react";
import "../../App.css";
import BookItem from "../BookItem";
import "../Cards.css";

export default function Books() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div
        className="blog-head-container"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1419640303358-44f0d27f48e7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=976&q=80)",
        }}
      >
        <h1>The Best Books</h1>
        <p>
          These are the books that influenced me the most. <br /> When you buy a
          book through these links, there is no extra charge for you and yet you
          still support me.
        </p>
      </div>
      <div>
        {/*style={{ backgroundColor: "rgb(230,230,230)" }} */}
        <div className="cards__container">
          <div className="cards__wrapper">
            <h1 className="cards__items__subtitle">Financial Intelligence</h1>
            <ul className="cards__items">
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/41zmM0asyKL._SX335_BO1,204,203,200_.jpg"
                title="Rich Dad Poor Dad"
                label="finance"
                path="https://amzn.to/3ykIzPH"
                subtitle="Rich dad poor dad is probably the book that influenced me the most and also gave me the confidence to go my own way and still achieve financial freedom. "
              />

              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/41eyZQt8x6S._SX331_BO1,204,203,200_.jpg"
                title="The Millionaire Fastlane"
                label="finance"
                path="https://amzn.to/3Ao1aLv"
                subtitle="An autobiography about leaving mediocrity. The book is very motivating and shows you very clearly the benefits of working for yourself."
              />
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/51YCf2t-JIL._SX331_BO1,204,203,200_.jpg"
                title="Unscripted"
                label="Entrepreneurship"
                path="https://amzn.to/2VwapdB"
                subtitle="Similar to The Millionaires Fastlane, the book shows the abyss of mediocrity and strongly motivates to take a self-determined path."
              />
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/51efEpr6uzL._SX322_BO1,204,203,200_.jpg"
                title="Losing My Virginity"
                label="Entrepreneurship"
                path="https://amzn.to/3lBfwnl"
                subtitle="The very exciting autobiography of Richard Brandson who has gone a very different way and in whose vocabulary mediocrity has no meaning."
              />
            </ul>
            <h1 className="cards__items__subtitle">
              Fulfillment and Happiness
            </h1>
            <ul className="cards__items">
              <BookItem
                src="https://m.media-amazon.com/images/I/51Il8TGXWnL.jpg"
                title="The Way of the Superior Man"
                label="Relationships, Sexual Desire"
                path="https://amzn.to/3howmnE"
                subtitle="The book shows the differences between more masculine and feminine characters and the problems that arise in today's society because people no longer behave according to their nature."
              />
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/51971FRmZrL._SX324_BO1,204,203,200_.jpg"
                title="Meditations"
                label="Fulfillment, Meaning, Stoicism"
                path="https://amzn.to/3w7SV4x"
                subtitle="For me, meditation is the most valuable book I have ever read. It explains a way of life according to which every human being can become happy. "
              />
              <BookItem
                src="https://images-eu.ssl-images-amazon.com/images/I/41ZgK6u73qL._SY264_BO1,204,203,200_QL40_ML2_.jpg"
                title="Man's Search for Meaning"
                label="Meaning"
                path="https://amzn.to/3xCupst"
                subtitle="A breathtaking historical autobigraphy of a concentration camp inmate which, unlike other historical stories of the time, does not focus on the misdeeds of the Nazis but on the meaning of life."
              />
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/51hB-QLkeRL._SX324_BO1,204,203,200_.jpg"
                title="The Obstacle is the Way"
                label="Stoicism"
                path="https://amzn.to/3AwzFzt"
                subtitle="Ryan Holiday is often hailed as an authorial wunderkind and after reading this book I can understand that. The book gives a nice introduction to Stoicism and explains through historical events how to deal with hindrances."
              />
            </ul>
            <h1 className="cards__items__subtitle">Self Improvement</h1>
            <ul className="cards__items">
              <BookItem
                src="https://m.media-amazon.com/images/I/513Y5o-DYtL.jpg"
                title="Atomic Habits"
                label="Habits"
                path="https://amzn.to/3cytDEL"
                subtitle="This is the first and most important book that has managed to establish a working method for developing good habits. It is not only incredibly motivating but also gives you practical instructions."
              />
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/41ojJPyHbIL._SX331_BO1,204,203,200_.jpg"
                title="The Willpower Instinct"
                label="Habits, Willpower"
                path="https://amzn.to/3fEEQoS"
                subtitle="This book explains willpower, discipline and habits in a way that is not only very science-based but also motivating. "
              />
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/51S1IFlzLcL._SX321_BO1,204,203,200_.jpg"
                title="The 7 Habits of Highly Effective People"
                label="Habits, Productivity"
                path="https://amzn.to/3bnc0qO"
                subtitle="Be proactive and focus on things you can control. Act in a way that makes you proud of yourself in the end. Don't talk about it, do it. Think win-win. Understand before you can be understood. invest in yourself."
              />
              <BookItem
                src="https://images-na.ssl-images-amazon.com/images/I/415Scelv5BL._SX324_BO1,204,203,200_.jpg"
                title="Eat That Frog!"
                label="Habits, Productivity"
                path="https://amzn.to/3lDuXeN"
                subtitle="A short book with structured and quality information on how to be more productive. I use some of the techniques in the book and read it annually."
              />
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
